/**
 * JS envoked checkout button
 *
 * @class DoCheckout
 * @typedef {DoCheckout}
 * @extends {HTMLElement}
 */
class DoCheckout extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", () => {
      window.location.href = "/checkout?locale=" + window.routes.language_iso;
    });
  }

}

customElements.define("do-checkout", DoCheckout);